import { create } from 'zustand';
import useUserStore from '@services/stores/UserStore';
import { OrderHistoryItem, OrderModel } from '@services/types/MyNewportOrderTypes';

interface AccountState {
    orderHistory: OrderHistoryItem[];
    methods: {
        getOrders(): Promise<OrderHistoryItem[]>
        getOrder(id: number): Promise<OrderModel | null>
    }
}

function getUserStore() {
    return useUserStore.getState();
}

const useAccountStore = create<AccountState>()(
    (set, get) => ({
        orderHistory: [],
        methods: {
            async getOrders(): Promise<OrderHistoryItem[]> {
                if (get().orderHistory?.length) {
                    return get().orderHistory;
                }

                const service = getUserStore().getService();
                const latestOrders = await service.getOrders();

                if (!Array.isArray(latestOrders?.data)) {
                    return [];
                }

                set({orderHistory: latestOrders.data})

                return latestOrders.data;
            },
            async getOrder(id: number): Promise<OrderModel | null> {
                const order = await getUserStore().getService().getOrder(id);
                return order.data.data;
            },
        },
    }),
);

export default useAccountStore;
